import path from "node:path";

import type { BuildTask, GeneratedForm } from "../../../../../Generator/src";
import { ThreadPool } from "../../../../../Common/multithread/ThreadPool";

import type { CallResponse, GeneratedFormWorkerMessage } from "./ReadSourcesAndProcessSugarWorker";

// Candy always runs from compiled `distr/` where `.js` file exists.
const WORKER_JS_FILENAME = "ReadSourcesAndProcessSugarWorker.js";
const defaultWorkerScriptPath = path.join(__dirname, WORKER_JS_FILENAME);

interface Options {
    workerPath?: string;
    maxWorkers?: number;
}

export class GeneratorPool {
    private pool?: ThreadPool;

    public constructor(generatorPath: string, options: Options = {}) {
        const { maxWorkers = 1, workerPath = defaultWorkerScriptPath } = options;
        this.pool = new ThreadPool({
            workerPath: workerPath,
            size: Math.max(1, maxWorkers),
            workerOptions: { workerData: { generatorPath: generatorPath } },
        });
    }

    public async generate(message: BuildTask): Promise<GeneratedForm> {
        if (!this.pool) {
            throw new Error("GeneratorPool: exec on disposed pool");
        }
        const response = await this.pool.exec<BuildTask, CallResponse>(message);
        if (response.type === "Error") {
            throw new Error(response.errorText);
        }
        return this.reconstructForm(response.generatedForm);
    }

    public async dispose(): Promise<void> {
        await this.pool?.dispose();
        this.pool = undefined;
    }

    /** Восстанавливаем ArrayBuffer -> Buffer (zero-copy view) для записи на диск */
    private reconstructForm(formContent: GeneratedFormWorkerMessage): GeneratedForm {
        const result: GeneratedForm = {};
        for (const [key, item] of Object.entries(formContent)) {
            result[key] = item instanceof ArrayBuffer ? Buffer.from(item) : item;
        }
        return result;
    }
}
